<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 复合日期搜索框 -->
      <!--<template #start>
        <CompositeFormDate ref="comFormDate" :type="'date'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>-->
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`运费统计表`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceFeightStatistics",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "财务管理", path: `/finance/feightStatistics` },
        { name: "运费统计表", path: `/finance/feightStatistics` },
      ],
      wxtsList: [
        {
          name: '运单毛利额=公司运费-出车费用-附加费用-亏吨金额+补差金额'
        },
      ],
      formInline: {
        predict_loading_date: null,
        predict_unloading_date: null,
        date: "",
        fleet: "",
        license: "",
        pname: "",
        driver: "",
      },
      searchDateOptions: [
        { ...this.ctrls.ZhuangHuoRiQi, },
        { ...this.ctrls.XieHuoRiQi, },
      ],
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.license,
        },
        {
          label: "客户名称",
          keyName: "pname",
          placeholder: "请填写客户名称",
          type: "text",
        },
        // {
        //   label: "司机姓名：",
        //   keyName: "driver",
        //   placeholder: "请填写司机姓名",
        //   type: "text",
        // },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 130 },
        { keyName: "license", label: "车牌号", minwidth: 100 },
        { keyName: "driver", label: "司机姓名", minwidth: 100 },
        { keyName: "shname", label: "客户名称", minwidth: 220 },
        { keyName: "name", label: "货物名称", minwidth: 220 },
        { keyName: "pricing", label: "计价方式", minwidth: 180 },
        { keyName: "coaddress", label: "装货地址", minwidth: 150 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 150 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', minwidth: 140 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 140 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "司机运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "total", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "profit", label: "运单毛利额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: [
        'inton',
        'unton',
        'kuiton',
        'kuitotal',
        'infreight',
        'dfreight',
        'freight',
        'total',
        'additional_fees',
        'compen',
        'profit',
        'caton',
      ],
      getListUrl: 'freightrec',
    };
  },
  methods: {
    setFleet({ team }) {
      // console.log(team)
      this.formCtrl.map(v => {
        if (v.keyName == 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
      this.$forceUpdate()
      if (Object.keys(this.$route.query).length) {
        // const dates = this.getMonthRange(this.CURR_MONTH)
        // console.log(dates)
        // this.$set(this.formInline, 'predict_loading_date', dates)
        const { fleetName } = this.$route.query
        team.map(v => {
          if (v.nickname == fleetName) {
            this.$set(this.formInline, 'fleet', v.id)
          }
        })
        this.$nextTick(this.getList)
      }
    },
  },
  // watch: {
  //   formCtrl: {
  //     deep: true,
  //     handler() {
  //       // console.log(newVal)
  //       const { fleetIdx } = this.$route.query
  //       this.formInline.fleet = this.formCtrl[1].options[fleetIdx].value
  //       this.$nextTick(this.getList)
  //     },
  //   }
  // },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      // 车队长登录，默认搜索当前队长
      this.formInline.fleet = id
      // 不显示队长控件
      this.formCtrl.splice(0, 1)
      // 重置时保留队长检索
      this.baseParams.push('fleet')
    }
  },
  mounted() {
    this.getFleet()
    const { user_group_id } = this.user
    if (user_group_id == 5) {
      this.$nextTick(this.getList);
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 20px;
  position: relative;

  // &::after {
  //   position: absolute;
  //   content: "";
  //   right: 40px;
  //   top: 6px;
  //   width: 1px;
  //   height: 28px;
  //   overflow: hidden;
  //   background-color: #EBEDF0;
  // }
}
</style>